import React from "react";
import styled from "styled-components";
import { ReactComponent as DownloadIcon } from "../../assets/icons/iDownload.svg";
import DeleteIcon from "../../assets/icons/delete-icon.png";
import CloseIcon from "../../assets/icons/modal-close-icon.svg";
import { Img } from "../../constants/common/StyledGlobalConstants";
import PropTypes from "prop-types";

const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  position: relative;
  outline: none;

  &:hover::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.04);
    z-index: -1;
  }

  &:active::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.12);
    z-index: -1;
  }

  &:focus::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff;
    outline: ${(props) => (props.isFocusable ? "2px solid #ffffff" : "2px solid #0077b4")};
    z-index: -1;
  }
`;

function renderIcon(type) {
  if (type === "trash") {
    return <img style={{ width: "1rem", height: "1rem", marginTop: "5px" }} src={DeleteIcon} alt="delete" />;
  }
  if (type === "close") {
    return <Img aria-label="close-image" src={CloseIcon} alt="close button" width="1rem" height="1rem" style={{ cursor: "pointer" }} />;
  }
  return <DownloadIcon />;
}

const CPIcon = ({ id, tabIndex, ariaLabel, clickHandler, type, outlineNotRequired = false }) => {
  return (
    <div>
      <DownloadButton
        id={id}
        isFocusable={type === "close" && !outlineNotRequired}
        tabIndex={tabIndex}
        aria-label={ariaLabel}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => clickHandler()}
      >
        {renderIcon(type)}
      </DownloadButton>
    </div>
  );
};

CPIcon.defaultProps = {
  clickHandler: () => {},
  type: "",
};

CPIcon.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ariaLabel: PropTypes.string,
  clickHandler: PropTypes.func,
  type: PropTypes.string,
  outlineNotRequired: PropTypes.bool,
};

export default CPIcon;